import { render } from "./StudyOverlay.vue?vue&type=template&id=be2a0336&scoped=true"
import script from "./StudyOverlay.vue?vue&type=script&lang=js"
export * from "./StudyOverlay.vue?vue&type=script&lang=js"

import "./StudyOverlay.vue?vue&type=style&index=0&id=be2a0336&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2a0336"]])

export default __exports__